// extracted by mini-css-extract-plugin
export default {"app-container":"App_app-container__Fyu4N","sidebar-collapsed":"App_sidebar-collapsed__CW16Q","main-area":"App_main-area__GkJcr","main-content-area":"App_main-content-area__0P+h6"};